module.exports = __webpack_public_path__ + "media/images/backgrounds/custom-turrets-d321033cb1100007503b1390df02028404ed9ece5fd4b1f48bc29e40b2fc0190.jpg";